import {isEmpty} from 'lodash'
import React, {useCallback, useContext, useEffect, useState} from 'react'
import {CommonService} from '../../app/modules/common'
import {StorageHelpers} from '../helpers/StorageHelpers'
import {useLanguage} from '../i18n/Metronici18n'
import {useAuth} from './AuthProvider'

const STATES_GLOBAL_STORAGE_KEY =
  process.env.REACT_APP_STATES_GLOBAL_STORAGE_KEY || 'STATES_GLOBAL_STORAGE_KEY'

export interface StatesGlobalContextModel {
  statesGlobal: any
}

const initStatesGlobalContextPropsStates = {
  statesGlobal: StorageHelpers.getItemLocalStorage(STATES_GLOBAL_STORAGE_KEY),
}

const StatesGlobalContext = React.createContext<StatesGlobalContextModel>(
  initStatesGlobalContextPropsStates
)

const StatesGlobalProvider: React.FC = ({children}) => {
  const {currentUser} = useAuth()
  const {language} = useLanguage()
  let [statesGlobal, setStateGlobal] = useState(
    StorageHelpers.getItemLocalStorage(STATES_GLOBAL_STORAGE_KEY)
  )
  const [settingsConfig, setSettingsConfig] = useState<Object>(statesGlobal?.settingsConfig)

  // begin: state global settings config
  const getSettingsConfig = useCallback(async () => {
    try {
      const {data} = await CommonService.getSettingsConfig()
      setSettingsConfig(data)
    } catch (error) {
      console.error(error)
    }
  }, [])

  useEffect(() => {
    // Refetch when settings is empty or the cached settings belong to another language.
    if (currentUser && (isEmpty(settingsConfig) || statesGlobal?.language !== language)) {
      getSettingsConfig()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getSettingsConfig, currentUser, language])
  // end: state global settings config

  // Persist global state together with the language it was fetched for.
  useEffect(() => {
    StorageHelpers.setItemLocalStorage(STATES_GLOBAL_STORAGE_KEY, {
      settingsConfig: settingsConfig,
      language: language,
    })

    setStateGlobal(StorageHelpers.getItemLocalStorage(STATES_GLOBAL_STORAGE_KEY))
  }, [settingsConfig, language])

  return (
    <StatesGlobalContext.Provider
      value={{
        statesGlobal,
      }}
    >
      {children}
    </StatesGlobalContext.Provider>
  )
}

function useStatesGlobal() {
  return useContext(StatesGlobalContext)
}

export {StatesGlobalProvider, useStatesGlobal}
